<template>
  <div>
    <div style="text-align-last: right">
      <b-button
        :disabled="itensSelecionados.length < 1"
        variant="primary"
        class="mb-1"
        @click="enturmarAlunos"
      >
        {{ $t('ACADEMICO.ENTURMAR_ALUNOS') }}
      </b-button>
    </div>
    <b-table
      head-variant="light"
      :fields="fields"
      :items="items"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      stacked="md"
      responsive
      show-empty
      striped
      hover
    >
      <template #cell(marcar)="item">
        <b-form-checkbox
          v-model="item.item.checked"
          :value="true"
          :unchecked-value="false"
          @change="marcaDesmarcaUm(item.item)"
        />
      </template>
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default">
          <b-dropdown-item @click="ensalar(item.item)" v-if="podeEditar">
            Alterar turma
          </b-dropdown-item>
          <b-dropdown-item
            @click="desenturmar(item.item)"
            v-if="!alunosSemTurma && podeEditar"
          >
            Remover da turma
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import TurmaService from '@/common/services/academico/turma.service';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
    alunosSemTurma: { type: Boolean, default: false },
    refiltrar: { type: Boolean, default: false },
  },
  data() {
    return {
      itensSelecionados: [],
      listaTemporaria: [],
      fields: [
        {
          key: 'marcar',
          label: '',
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'codigoContrato',
          label: 'Matrícula',
          sortable: true,
        },
        {
          key: 'codigoMatricula',
          label: 'Contrato',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
    };
  },
  watch: {
    refiltrar: {
      handler() {
        this.itensSelecionados = [];
      },
      deep: true,
    },
  },
  methods: {
    enturmarAlunos() {
      this.$emit('enturmar-varios-alunos', this.itensSelecionados);
    },
    marcaDesmarcaUm() {
      this.itensSelecionados = [];
      this.items.forEach((item) => {
        if (item.checked) {
          this.itensSelecionados.push(item);
        }
      });
    },
    ensalar(item) {
      this.$emit('ensalar', 'ensalamento', item);
    },
    desenturmar(item) {
      this.$store.dispatch(START_LOADING);
      TurmaService.desenturmarAluno(item)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO.GERENCIADOR_TURMAS_ALUNO_REMOVIDO')
          );
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
